"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.delete.confirm': 'Delete Tutorial',
    'tutorial.delete.confirmText': 'Are you sure you want to delete this tutorial? This action cannot be undone.',
    'tutorial.delete.success': 'Tutorial deleted successfully',
};
